import type { TOC } from '@ember/component/template-only'
import type { WithBoundArgs } from '@glint/template'
import { hash } from '@ember/helper'
import { BasicTableRow } from 'teacher-ui-client/components/stable-table/basic-table/row'
import type { ColumnObject, RowObject } from 'teacher-ui-client/components/stable-table/basic-table/cell'
import type { Config } from 'teacher-ui-client/components/stable-table/basic-table'

interface FootSignature {
  Element: HTMLTableSectionElement
  Args: {
    /** is provided footerRows */
    rows?: RowObject[]
    /** is provided footerColumns */
    columns: ColumnObject[]
    config?: Config
  }
  Blocks: { default: [{ row: WithBoundArgs<typeof BasicTableRow, 'rowObject' | 'columns' | 'rowIndex' | 'config'> }] }
}

export const BasicTableFoot: TOC<FootSignature> = <template>
  <tfoot data-test-basic-table-foot ...attributes>
    {{#each @rows as |rowObject index|}}
      {{#let (component BasicTableRow rowObject=rowObject columns=@columns rowIndex=index config=@config) as |row|}}
        {{#if (has-block)}}
          {{yield (hash row=row)}}
        {{else}}
          {{row}}
        {{/if}}
      {{/let}}
    {{/each}}
  </tfoot>
</template>

export default BasicTableFoot
